// extracted by mini-css-extract-plugin
module.exports = {"loader":"LimitedAccessBanner_loader__3EjlI","root":"LimitedAccessBanner_root__1fNuX","text":"LimitedAccessBanner_text__1YprW","button":"LimitedAccessBanner_button__sYbOM"};